import hoverIntent from '../../libs/hoverIntent';

/**
 * Megadrop
 * Functions for the megadrop.
 * @version 3.0.0
 * @exports Megadrop
 */
export default class Megadrop {

	/**
	 * Constructor
	 * @public
	 */
	constructor () {
		this._initHoverIntent();
		this._initKeyboardNavigation();
	}

	/**
	 * Add megadrop hover function with the hoverIntent plugin.
	 * @private
	 */
	_initHoverIntent() {
		let els = document.querySelectorAll('.has-megadrop');

		els.forEach(el => {
			hoverIntent(
				el,
				function() {
					this.firstElementChild.setAttribute("aria-expanded", true);
					this.classList.add('megadrop-active');
					document.body.classList.add('megadrop-active');
				},
				function() {
					this.firstElementChild.setAttribute("aria-expanded", false);
					this.classList.remove('megadrop-active');
					document.body.classList.remove('megadrop-active');
				}
			).options({
				timeout: 0,
				interval: 0,
			});
		});

		document.documentElement.classList.remove('megadrop-uninitiated'); // Removal of this class will disable megadrop display through css hovering.
	}


	/**
	 * Add keyboard tab navigation to megadrop.
	 * @private
	 */
	_initKeyboardNavigation () {
		let els = document.querySelectorAll('.has-megadrop');

		els.forEach((el) => {
			el.addEventListener('keydown', (event) => {
				if (event.keyCode === 13) {
					if (!el.classList.contains('megadrop-active')) {
						event.preventDefault();
						el.firstElementChild.setAttribute("aria-expanded", true);
						el.classList.add('megadrop-active');
						document.body.classList.add('megadrop-active');
					}
				}
			});

			el.addEventListener('focus', () => {
				if (el.getAttribute('data-focusOutTimer') !== undefined) {
					clearTimeout(el.getAttribute('data-focusOutTimer'));
				}
			}, true);

			el.addEventListener('blur', () => {
				el.setAttribute('data-focusOutTimer', setTimeout(() => {
					el.firstElementChild.setAttribute("aria-expanded", false);
					el.classList.remove('megadrop-active');
					document.body.classList.remove('megadrop-active');
				}, 50));
			}, true);
		});
	}
}
